
import { mapGetters } from 'vuex'
import Purchase from '../PurchaseAction/Purchase.vue'

function convertM2H(n) {
  const num = n
  const day = num / 3600
  const rday = Math.floor(day)
  const hours = (day - rday) * 60
  const rhours = Math.floor(hours)
  const minutes = (hours - rhours) * 60
  const rminutes = Math.round(minutes)
  return (
    (rday >= 1 ? (rday < 10 ? `0${rday}` : rday) + ':' : '') +
    (rhours < 10 ? `0${rhours}` : rhours) +
    ':' +
    (rminutes < 10 ? `0${rminutes}` : rminutes)
  )
}
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  data() {
    return {
      showPurchase: false,
      days: [
        { value: null, label: this.$custom$t('access.allTime') },
        { value: 1, label: this.$custom$t('access.day', { day: 1 }) },
        { value: 2, label: this.$custom$t('access.day', { day: 2 }) },
        { value: 3, label: this.$custom$t('access.day', { day: 3 }) },
        { value: 5, label: this.$custom$t('access.day', { day: 5 }) },
        { value: 7, label: this.$custom$t('access.week', { week: 1 }) },
        { value: 10, label: this.$custom$t('access.day', { day: 10 }) },
        { value: 15, label: this.$custom$t('access.day', { day: 15 }) },
        { value: 20, label: this.$custom$t('access.day', { day: 20 }) },
        { value: 30, label: this.$custom$t('access.month', { month: 1 }) },
        { value: 60, label: this.$custom$t('access.month', { month: 2 }) },
        { value: 90, label: this.$custom$t('access.month', { month: 3 }) },
        { value: 30 * 6, label: this.$custom$t('access.month', { month: 6 }) },
        { value: 30 * 12, label: this.$custom$t('access.year', { year: 1 }) },
      ],
    }
  },
  computed: {
    accessDate() {
      const day = this.days.find((d) => d.value === this.product.accessDuration)
      if (day) return day.label
      else return '-'
    },
    videoLength() {
      return this.product.sections.reduce(
        (sum, { videos }) => sum + videos.length,
        0
      )
    },
    totalVideoDuration() {
      return this.product.sections.reduce(
        (sum, { totalVideoDuration }) => sum + totalVideoDuration,
        0
      )
    },
    url() {
      if (!process.server) return location.origin + this.$route.fullPath
      return ''
    },
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    convertM2H,
  },
  components: { Purchase },
}
